import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className"];
import React from 'react';
import { cnBem } from '@carnica/utils';
import { SkeletonBrick } from "../../Skeleton";
import styles from "./styles.pcss";
var cnTextArea = cnBem('skeleton-textarea', styles);
export var TextArea = function TextArea(_ref) {
  var className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cnTextArea(null, [className])
  }, props), /*#__PURE__*/React.createElement(SkeletonBrick, {
    height: 12,
    width: 100
  }), /*#__PURE__*/React.createElement(SkeletonBrick, {
    height: 28,
    width: "100%"
  }));
};